import type {ImpersonationUserRef} from "@/src/modules/core/types/impersonation";

export type {
  ImpersonationState,
  ImpersonationUserRef,
} from "@/src/modules/core/types/impersonation";

export type ImpersonationStatus =
  | {active: false}
  | {
      active: true;
      session_id: number;
      read_only: boolean;
      started_at?: string;
      expires_at: string;
      target: ImpersonationUserRef;
    };

export type StartImpersonationPayload = {
  target_user_id: number;
  reason: string;
  ticket_id?: string;
};

export type StartImpersonationResult = {
  impersonation_session_id: number;
  token_type: string;
  access_token: string;
  expires_at: string;
  read_only: boolean;
  target: ImpersonationUserRef;
};

export type EndImpersonationResult = {
  ended: boolean;
  impersonation_session_id: number;
};

export const IMPERSONATION_RESUME_REASON = "Resuming active support view session";
